var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-notify"},[_c('div',{staticClass:"base-notify__body"},[(_vm.icon)?_c('base-icon',{staticClass:"base-notify__icon",attrs:{"name":_vm.icon,"width":"24","height":"24"}}):_vm._e(),_vm._t("default")],2),_vm._t("btn",null,{"btnClass":"base-notify__btn"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }